import type {
  ActiveCoupon,
  MemberReward,
} from "@/api/giftcard.api";
import type { CouponItem, RewardItem } from "./types";

function formatMemberExpiry(value?: string) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export function mapMembersRewardsToItems(
  rewards: MemberReward[] = []
): RewardItem[] {
  return rewards.map((reward, index) => ({
    id: `${reward.couponCode ?? "reward"}-${index}`,
    name: reward.ruleName?.trim() || "Reward",
    couponCode: reward.couponCode?.trim() || "",
    couponValue: reward.couponValue?.trim() || "",
    expiry: reward.expiry
      ? `Expires ${formatMemberExpiry(reward.expiry)}`
      : "",
  }));
}

export function mapActiveCouponsToItems(
  coupons: ActiveCoupon[] = []
): CouponItem[] {
  return coupons.map((coupon, index) => ({
    id: `${coupon.ruleName ?? "coupon"}-${index}`,
    title: coupon.ruleName?.trim() || "Coupon",
    code: "",
    discount: coupon.couponValue?.trim() || "",
    description: coupon.minimumPurchase?.trim()
      ? `Minimum purchase ${coupon.minimumPurchase}`
      : "",
    expiry: coupon.expiry
      ? `Expires ${formatMemberExpiry(coupon.expiry)}`
      : "",
    status: "ACTIVE",
  }));
}
